import { render, staticRenderFns } from "./merchant-train.vue?vue&type=template&id=7c64f8ce&scoped=true"
import script from "./merchant-train.vue?vue&type=script&lang=js"
export * from "./merchant-train.vue?vue&type=script&lang=js"
import style0 from "./merchant-train.vue?vue&type=style&index=0&id=7c64f8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c64f8ce",
  null
  
)

export default component.exports